import styled from '@emotion/styled';
import { LinkVariant } from './link.types';
import { LinkSize } from './link.types';
import { css } from '@emotion/react';

export const Link = styled('a', {
  shouldForwardProp: (prop) => !['isFocusVisible', 'as'].includes(prop as string),
})<{
  variant: LinkVariant;
  size: LinkSize;
  isFocusVisible: boolean;
}>`
  text-decoration: none;
  display: inline-block;
  transition: all 0.2s ease;
  position: relative;
  outline: none;
  cursor: pointer;
  appearance: none;
  border: none;
  background-color: transparent;

  /* Size variants */
  ${({ size }) =>
    ({
      16: css`
        font-size: 16px;
        line-height: 24px;
      `,
      12: css`
        font-size: 12px;
        line-height: 16px;
      `,
    }[size])}

  /* Variant styles */
  ${({ variant, theme }) =>
    ({
      default: css`
        color: ${theme.colors.primary.normal};
        &:hover {
          color: ${theme.colors.primary.medium};
        }
        &:active {
          color: ${theme.colors.primary.dark};
        }

        /* Hover underline only for default variant */
        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 100%;
          height: 1px;
          background-color: currentColor;
          transform: scaleX(0);
          transition: transform 0.2s ease;
        }

        &:hover:after {
          transform: scaleX(1);
        }
      `,
      subtle: css`
        color: ${theme.colors.technical.gray[60]};
        &:hover {
          color: ${theme.colors.technical.adaptive};
        }
        &:active {
          color: ${theme.colors.technical.adaptive};
        }
      `,
    }[variant])}

  /* Focus ring */
  ${({ isFocusVisible, theme }) =>
    isFocusVisible &&
    css`
      &:before {
        content: '';
        position: absolute;
        inset: -1px -3px;
        border-radius: 8px;
        border: 2px solid ${theme.colors.primary.medium};
      }
    `}
`;
